// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blogs-wrap {
    padding: 91px 100px;
    background: #150924;
    color: white;
}

.blogs-wrap .heading {
    font-size: 56px;
    font-weight: 700;
    line-height: 68px;
    text-align: left;
    color: white;
    padding: 0;
}

.blogs-wrap .description {
    font-size: 20px;
    font-weight: 400;
    line-height: 34px;
    text-align: left;
    margin: 0;
}

.blogs-wrap .subheading {
    font-size: 28px;
    font-weight: 700;
    line-height: 68px;
    text-align: left;
}

.blogs-wrap .blogs-card-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 52px;
    margin-top: 30px;
    margin-bottom: 60px;
}

.blogs-wrap .card-wrap {
    /* max-width: 594px; */
    /* width: 48%; */
    background: #271c35;
}

.blogs-wrap .card-wrap .title {
    font-size: 20px;
    font-weight: 800;
    line-height: 28px;
    text-align: left;
    margin: unset;
    font-family: "Inter", sans-serif;
}

.blogs-wrap .card-wrap .description {
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    text-align: left;
    margin-top: 2px;
    margin-bottom: 20px;
}

.blogs-wrap .card-wrap .card-content-wrap {
    padding: 22px;
}

.blogs-wrap .card-wrap .blog-date {
    font-size: 14px;
    font-weight: 400;
    line-height: 26px;
    text-align: left;
    opacity: 40%;
}

.blogs-wrap .card-wrap .read-btn a {
    font-size: 18.33px;
    font-weight: 800;
    line-height: 13.33px;
    text-align: left;
    color: #06efc5 !important;
    display: flex;
    gap: 15px;
    align-items: center;
    text-decoration: none !important;
}

.blogs-wrap .card-wrap .read-btn a:hover {
    text-decoration: none !important;
}

.blogs-wrap .card-wrap .read-btn .arrow {
    width: 24px;
}

.blogs-wrap .primaryButton {
    background: #06efc5;
    font-size: 18px;
    font-weight: 800;
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
    color: black;
}

.blogs-wrap .email-wrap {
    margin-bottom: 34px;
    background-color: #231b2e;
    padding: 10px;
    border: 0;
    margin-top: 30px;
    width: 545px;
}

.blogs-wrap .email-input {
    background: transparent;
    border: 0;
    color: white;
}

@media screen and (max-width: 768px) {
    .blogs-wrap {
        padding: 70px 25px;
        text-align: center;
    }

    .blogs-wrap .email-wrap {
        width: 100%;
        flex-direction: column;
        background-color: unset;
        gap: 12px;
    }

    .blogs-wrap .email-input {
        width: 100%;
        background-color: #231b2e;
    }

    .blogs-wrap .email-wrap .primaryButton {
        width: 100%;
    }
}

@media screen and (max-width: 480px) {
    .blogs-wrap .heading {
        font-size: 25px;
        line-height: 68px;
        margin: auto;
    }

    .blogs-wrap .description {
        font-size: 15px;
        font-weight: 400;
        line-height: 34px;
        text-align: center;
    }

    .blogs-wrap .email-wrap {
        margin-top: 0;
    }

    .blogs-wrap .blogs-card-wrapper {
        grid-template-columns: 1fr;
    }

    .blogs-wrap .pagination-wrap .btn-text {
        display: none;
    }

    .blogs-wrap .card-wrap .card-content-wrap {
        padding: 25px 14px;
    }

    .blogs-wrap .subheading {
        font-size: 25px;
        text-align: center;
    }

    .blogs-wrap .card-wrap .title {
        font-size: 15px;
        line-height: 20px;
    }

    .blogs-wrap .card-wrap .blog-date {
        margin-top: 10px;
        margin-bottom: 20px;
    }

    .blogs-wrap .card-wrap .description {
        font-size: 15px;
        margin-bottom: 0;
    }

    .blogs-wrap .card-wrap .read-btn {
        font-size: 15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/LandingPages/Blogs.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI;QACI,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".blogs-wrap {\n    padding: 91px 100px;\n    background: #150924;\n    color: white;\n}\n\n.blogs-wrap .heading {\n    font-size: 56px;\n    font-weight: 700;\n    line-height: 68px;\n    text-align: left;\n    color: white;\n    padding: 0;\n}\n\n.blogs-wrap .description {\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 34px;\n    text-align: left;\n    margin: 0;\n}\n\n.blogs-wrap .subheading {\n    font-size: 28px;\n    font-weight: 700;\n    line-height: 68px;\n    text-align: left;\n}\n\n.blogs-wrap .blogs-card-wrapper {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 52px;\n    margin-top: 30px;\n    margin-bottom: 60px;\n}\n\n.blogs-wrap .card-wrap {\n    /* max-width: 594px; */\n    /* width: 48%; */\n    background: #271c35;\n}\n\n.blogs-wrap .card-wrap .title {\n    font-size: 20px;\n    font-weight: 800;\n    line-height: 28px;\n    text-align: left;\n    margin: unset;\n    font-family: \"Inter\", sans-serif;\n}\n\n.blogs-wrap .card-wrap .description {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 26px;\n    text-align: left;\n    margin-top: 2px;\n    margin-bottom: 20px;\n}\n\n.blogs-wrap .card-wrap .card-content-wrap {\n    padding: 22px;\n}\n\n.blogs-wrap .card-wrap .blog-date {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 26px;\n    text-align: left;\n    opacity: 40%;\n}\n\n.blogs-wrap .card-wrap .read-btn a {\n    font-size: 18.33px;\n    font-weight: 800;\n    line-height: 13.33px;\n    text-align: left;\n    color: #06efc5 !important;\n    display: flex;\n    gap: 15px;\n    align-items: center;\n    text-decoration: none !important;\n}\n\n.blogs-wrap .card-wrap .read-btn a:hover {\n    text-decoration: none !important;\n}\n\n.blogs-wrap .card-wrap .read-btn .arrow {\n    width: 24px;\n}\n\n.blogs-wrap .primaryButton {\n    background: #06efc5;\n    font-size: 18px;\n    font-weight: 800;\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    justify-content: center;\n    color: black;\n}\n\n.blogs-wrap .email-wrap {\n    margin-bottom: 34px;\n    background-color: #231b2e;\n    padding: 10px;\n    border: 0;\n    margin-top: 30px;\n    width: 545px;\n}\n\n.blogs-wrap .email-input {\n    background: transparent;\n    border: 0;\n    color: white;\n}\n\n@media screen and (max-width: 768px) {\n    .blogs-wrap {\n        padding: 70px 25px;\n        text-align: center;\n    }\n\n    .blogs-wrap .email-wrap {\n        width: 100%;\n        flex-direction: column;\n        background-color: unset;\n        gap: 12px;\n    }\n\n    .blogs-wrap .email-input {\n        width: 100%;\n        background-color: #231b2e;\n    }\n\n    .blogs-wrap .email-wrap .primaryButton {\n        width: 100%;\n    }\n}\n\n@media screen and (max-width: 480px) {\n    .blogs-wrap .heading {\n        font-size: 25px;\n        line-height: 68px;\n        margin: auto;\n    }\n\n    .blogs-wrap .description {\n        font-size: 15px;\n        font-weight: 400;\n        line-height: 34px;\n        text-align: center;\n    }\n\n    .blogs-wrap .email-wrap {\n        margin-top: 0;\n    }\n\n    .blogs-wrap .blogs-card-wrapper {\n        grid-template-columns: 1fr;\n    }\n\n    .blogs-wrap .pagination-wrap .btn-text {\n        display: none;\n    }\n\n    .blogs-wrap .card-wrap .card-content-wrap {\n        padding: 25px 14px;\n    }\n\n    .blogs-wrap .subheading {\n        font-size: 25px;\n        text-align: center;\n    }\n\n    .blogs-wrap .card-wrap .title {\n        font-size: 15px;\n        line-height: 20px;\n    }\n\n    .blogs-wrap .card-wrap .blog-date {\n        margin-top: 10px;\n        margin-bottom: 20px;\n    }\n\n    .blogs-wrap .card-wrap .description {\n        font-size: 15px;\n        margin-bottom: 0;\n    }\n\n    .blogs-wrap .card-wrap .read-btn {\n        font-size: 15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
